
export class DashboardLayoutsBusParam {
    layoutId: any;
    userId: string;
    layout: string;
    insertDt: Date;
    updateDt: Date;
    insertUserId: string;
    updateUserId: string;
    layoutName: string;
    defaultLayout: boolean;
}
